import styled from 'styled-components'
import getBreakpoint from '@client/utils/breakpoints'

export const Wrapper = styled.section`
  position: relative;
  background-color: #ffffff;
  box-shadow: 0px 4px 12px rgba(152, 152, 167, 0.25);
  height: 56px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    height: 96px;
  }
`

export const Logo = styled.img`
  height: 16px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    height: 30px;
  }
`

export const Content = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 20px;
  width: 100%;

  @media (min-width: ${getBreakpoint('xl')}px) {
    padding-top: 30px;
    padding-bottom: 36px;
  }
`

export const ContentRight = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
